module.exports = __webpack_public_path__ + "static/media/backgroundMountains.6009349a.png";